export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6170.ab801f89.jpg";